import React from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header';
import AssignSamplePeople from './AssignSamplePeople';

/**
 * The portal-side door onto the assignment screen.
 *
 * The HINC DT manager and the Development manager reach it from the mail the portal sends when a
 * SKU is approved and its Sample ID is minted (Max, 2026-10-04: "để họ vào check lại thông tin và
 * phân bổ nhân sự phụ trách"). The receiving team reaches the SAME screen from the ticket link,
 * without a login — see AssignSamplePeople, which both routes render.
 */
export default function AssignPeoplePage() {
  const { groupId } = useParams();
  return (
    <div className="portal-shell">
      <Header />
      <div style={{ maxWidth: 940, margin: '0 auto', padding: '24px 16px' }}>
        <AssignSamplePeople api={`/api/development/assign/${encodeURIComponent(groupId)}`} />
      </div>
    </div>
  );
}
